
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Alert } from '@/Alert'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';

@Component({
  name: 'AlertDealsListComponent',
  components: { }
})
export default class AlertDealsListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public alert: Alert

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public onEdit(alert: Alert) {
    this.$emit('clicked-edit', alert)
  }
  public onDelete(alert: Alert) {
    this.$emit('clicked-delete', alert)
  }


  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
